import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Footer from './Footer';
import LandingPage from './LandingPage';
import About from './About';
import Contact from './Contact';
import NavBar from './Navbar';
import OwnerPage from './Owner/OwnerPage';
import ProductAddPage from './Owner/ProductAddPage';
import ProductSalesPage from './Owner/ProductSalesPage';
import Register from './Owner/Registration';
import OwnerHome from './Owner/OwnerHome';
import RetailerHome from './Retailer/RetailerHome';
import RetailerRegistration from './Retailer/RetailerRegistration';
import RetailerPurchase from './Retailer/RetailerPurchase';
import ProfileRetailer from './Retailer/ProfileRetailer';
import RetailerProductVerification from './Retailer/RetailerProductVerification';
import RetailerSale from './Retailer/RetailerSale';
import RetailerSalePayment from './Retailer/RetailerSalePayment';
import Consumer from './Consumers/Consumer.jsx';
import ProtectedRoute from './ProtectedRoute';
import './style.scss';

function App() {
  const [navbarCollapsed, setNavbarCollapsed] = useState(true);
  
  const handleToggleNavbar = () => {
    setNavbarCollapsed(!navbarCollapsed);
  };
  
  return (
    <Router>
      <div className="layout-container">
        <NavBar onToggle={handleToggleNavbar} />
        
        <div className="main-content">
          <Routes>
            {/* Main routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/About" element={<About />} />
            <Route path="/Contact" element={<Contact />} />
            <Route path="/Consumer" element={<Consumer />} />
            
            {/* Owner routes */}
            <Route path="/Ownerpage" element={<OwnerPage />} />
            <Route path='/Register' element={<Register />} />
            <Route path="/Owner-Home" element={<OwnerHome />} />
            <Route
              path="/Owner-Home/Add"
              element={<ProtectedRoute element={<ProductAddPage />} requiredRole="owner" />}
            />
            <Route
              path="/Owner-Home/Sale"
              element={<ProtectedRoute element={<ProductSalesPage />} requiredRole="owner" />}
            />
            
            {/* Retailer routes */}
            <Route path='/Retailer-Home' element={<RetailerHome />} />
            <Route path='/Retailer-Registration' element={<RetailerRegistration />} />
            <Route
              path='/Retailer-Home/Add'
              element={<ProtectedRoute element={<RetailerPurchase />} requiredRole="retailer" />}
            />
            <Route
              path='/Retailer-Home/Verification'
              element={<ProtectedRoute element={<RetailerProductVerification />} requiredRole="retailer" />}
            />
            <Route
              path='/Retailer-Home/SalesDashboard'
              element={<ProtectedRoute element={<RetailerSale />} requiredRole="retailer" />}
            />
            <Route
              path='/Retailer-Home/SalePayment'
              element={<ProtectedRoute element={<RetailerSalePayment />} requiredRole="retailer" />}
            />
            <Route
              path='/Retailer-Home/Profile'
              element={<ProtectedRoute element={<ProfileRetailer />} requiredRole="retailer" />}
            />
          </Routes>
        </div>
        
        <Footer />
      </div>
    </Router>
  );
}

export default App;